<div class="shell">
    <div class="sidenav-container">
        <app-sidenav 
            style="width: 10%; height: 100%;" 
            [isMobileOpen]="isMobileOpen" 
            [openMobile]="openMobile.bind(this)" 
            [closeMobile]="closeMobile.bind(this)"
            [homeState]="homeState"
            [bpState]="bpState"
            [fpState]="fpState"
            [cpState]="cpState"
            [disableDocuments]="disableDocuments"
            #sidenav
        ></app-sidenav>
    </div>
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
    <div class="shell-container" (click)="this.closeMobile()" #container>
        <app-contact-sideswipe></app-contact-sideswipe>
        <app-account-bubble></app-account-bubble>
        <div class="content" #content>
            <app-header headerText="{{this.headerText}}"></app-header>
            <div class="progress-bars" *ngIf="this.needsProgressBars">
                <app-progress-bar label="Business Profile" [stepsCompleted]="bpStepsCompleted" [stepsTotal]="bpStepsTotal"></app-progress-bar>
                <app-progress-bar label="Financial Profile" [stepsCompleted]="fpStepsCompleted" [stepsTotal]="fpStepsTotal"></app-progress-bar>
                <app-progress-bar label="Customer Portfolio" [stepsCompleted]="cpStepsCompleted" [stepsTotal]="cpStepsTotal"></app-progress-bar>
            </div>
            <app-serverside-alert></app-serverside-alert>
            <!-- TRANSCLUSION -->
            <ng-content (reportAlert)="this.reportAlert()"></ng-content>
        </div>
    </div>
</div>